










import {Component, Vue, Prop} from "vue-property-decorator";
import { Question } from '@/ts/types/question';

@Component
export default class QuizAnswer extends Vue{
  @Prop() private questions!: Array<Question>;
}
